
<template>
    <div class="page">
      <Header></Header>
      <div class="header-box">
          <div class="box-title-text">{{postion.name}}</div>
          <div class="box-tags">
            <van-tag v-if="postion.showWorkPlace" color="#e4ecfa" text-color="#206CFE">{{postion.showWorkPlace}}</van-tag>
<!--            <van-tag class="ellipsis" v-if="postion.tags" color="#f5eee9" text-color="#FF8E25">{{postion.tags}}</van-tag>-->
          </div>
      </div>
      <div class="body">
        <div v-if="postion.targetId=='1004'" style="margin-bottom: 16px;">
<!--          <div class="box-split"></div>-->
<!--          <div class="box2-title" style="margin-bottom: 16px">-->
<!--            <span style="color:#F25058;margin-right: 4px;height: 14px;">*</span>-->
<!--            个人规划及发展方向-->
<!--          </div>-->
<!--          <div class="box2">-->
<!--            <van-field v-model="resumeDetail.expectedJob" placeholder="请选择个人规划及发展方向" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native.prevent="showPopup($event,resumeDetail,'job')" />-->
<!--          </div>-->

            <div class="box-split"></div>
            <div class="box2-title" style="margin-bottom: 16px">
              <span style="color:#F25058;margin-right: 4px;height: 14px;">*</span>
              您是如何得知此次校园招聘信息的
            </div>
            <div class="box2">
              <van-field v-model="knowTypeName" placeholder="请选择" required label="信息来源" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native.prevent="showPopup($event,knowTypeName,'knowType')" />
              <van-field v-if="!knowSourceIsText()" v-model="knowSourceName" required placeholder="请选择" label="请选择　" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native.prevent="showPopup($event,knowSourceName,'knowSource')" />
              <van-field v-if="knowSourceIsText()" v-model="knowSource" maxlength="50" required :label="knowSourceTextLabel()" placeholder="请输入" />
            </div>

        </div>
        <div class="box-split"></div>
        <div class="box2-title">
          <span style="color:#F25058;margin-right: 4px;height: 14px;">*</span>
          附件简历
          <span class="box2-title-text-sub">（请上传简历，在完善个人信息)</span>
        </div>
        <div v-if="!loading && !resumePath" class="uploadbox">
          <van-uploader :accept="accept" :max-count="1" :max-size="maxFile" :before-read="onBeforeReadFile" :after-read="onAfterReadFile">
            <img :src="require('@/assets/add.png')" class="upload-icon" />
            <div class="upload-text">点击上传附件简历</div>
            <div class="upload-text-sub">支持格式：pdf、doc、docx</div>
          </van-uploader>
        </div>
        <div v-if="!loading && resumePath" class="filebox">
            <img :src="require('@/assets/file/'+fileIcon+'.png')" class="filebox-icon" />
            <div class="filebox-name">{{resumeDetail.Name?resumeDetail.Name+"的简历":"简历"}}</div>
            <van-uploader :accept="accept" :max-count="1" :max-size="maxFile" :before-read="onBeforeReadFile" :after-read="onAfterReadFile">
              <div class="filebox-btns">
                 重新上传
              </div>
            </van-uploader>
        </div>
        <div class="box-split"></div>
        <div class="box2-title">
          <span class="box2-title-icon"></span>
          完善个人信息
        </div>
        <div class="box2-title-text">基础信息</div>
        <div class="box2">
            <van-field v-model="resumeDetail.Name" maxlength="100" required label="姓名　　" placeholder="请输入姓名" />
            <van-field v-model="resumeDetail.Mobile" maxlength="11" required label="手机号　" placeholder="请输入手机号码" />
            <van-field v-model="resumeDetail.Email" maxlength="200" required label="邮箱　　" placeholder="请输入邮箱" />
            <van-field v-model="resumeDetail.Sex" required label="性別　　" placeholder="请选择性別" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event,resumeDetail,'sex')" />
        </div>
        <div style="height: 1px"></div>
        <div v-for="(item,i) in resumeDetail.EducationInfo" :key="'edu'+i">
            <div class="box-split"></div>
            <div v-if="i==0" class="box2-title-text">教育经历<span class="box2-title-text-sub">（请从本科学历开始填写)</span></div>
            <div class="box2">
                <van-field v-model="item.School" maxlength="100" required label="毕业院校" placeholder="请输入毕业院校" />
                <van-field v-model="item.Speciality" maxlength="100" required label="专业　　" placeholder="请输入专业" />
                <van-field v-model="item.StartDate" required label="开始时间" placeholder="请选择开始时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click.native="showStartDatePopup($event,item)" />
                <van-field v-model="item.EndDate" required label="结束时间" placeholder="请选择结束时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click.native="showEndDatePopup($event,item)" />
                <van-field v-model="item.Education" required label="学历　　" placeholder="请选择学历" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event,item,'edu')" />
                <van-field v-model="item.studyType" required label="是否统招" placeholder="请选择是否统招" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event,item,'study')" />
                <van-field class="pr" v-model="item.professionRanking" required label="专业排名" placeholder="请选择专业排名" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event,item,'prof')" />
                <div style="padding: 0 0 16px;"><!--请如实填写，面试时需携带相关材料--></div>
            </div>
            <div v-if="resumeDetail.EducationInfo.length==1" class="box2-btns">
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click="onAddEdu">
                添加教育经历
              </van-button>
            </div>
            <div v-if="resumeDetail.EducationInfo.length>1 && i!=resumeDetail.EducationInfo.length-1" class="box2-btns">
              <van-button class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelEdu($event,i)">
                删除教育经历
              </van-button>
            </div>
            <div v-if="resumeDetail.EducationInfo.length>1 && i==resumeDetail.EducationInfo.length-1" class="box2-btns">
              <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelEdu($event,i)">
                删除教育经历
              </van-button>
              <div style="width:12px;"/>
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddEdu">
                添加教育经历
              </van-button>
            </div>
        </div>
<!--        <div style="height: 1px"></div>-->
<!--        <div v-for="(item,i) in resumeDetail.internshipInfo" :key="'intern'+i">-->
<!--          <div class="box-split"></div>-->
<!--          <div v-if="i==0" class="box2-title-text">实习经历</div>-->
<!--          <div class="box2">-->
<!--            <van-field v-model="item.compayName" required label="企业名称" placeholder="请输入企业名称" />-->
<!--            <van-field v-model="item.position" required label="所任职位" placeholder="请输入所任职位" />-->
<!--            <van-field v-model="item.starttime" required label="开始时间" placeholder="请选择开始时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click="showStartDatePopup($event,item)" />-->
<!--            <van-field v-model="item.endtime" required label="结束时间" placeholder="请选择结束时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click="showEndDatePopup($event,item)" />-->
<!--            <van-field v-model="item.jobDetail" required label="工作描述" class="textarea" type="textarea" rows="5" placeholder="请输入工作描述" />-->
<!--          </div>-->
<!--          <div v-if="resumeDetail.internshipInfo.length>1 && i!=resumeDetail.internshipInfo.length-1" class="box2-btns">-->
<!--            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelIntern($event,i)">-->
<!--              删除实习经历-->
<!--            </van-button>-->
<!--          </div>-->
<!--          <div v-if="i==resumeDetail.internshipInfo.length-1" class="box2-btns">-->
<!--            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelIntern($event,i)">-->
<!--              删除实习经历-->
<!--            </van-button>-->
<!--            <div style="width:12px;"/>-->
<!--            <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddIntern">-->
<!--              添加实习经历-->
<!--            </van-button>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div v-if="!resumeDetail.internshipInfo || resumeDetail.internshipInfo.length==0">-->
<!--          <div class="box-split"></div>-->
<!--          <div class="box2-title-text">实习经历</div>-->
<!--          <div class="box2">-->
<!--            <div class="box2-btns">-->
<!--              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddIntern">-->
<!--                添加实习经历-->
<!--              </van-button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div style="height: 1px"></div>
        <div v-for="(item,i) in resumeDetail.ExperienceInfo" :key="'job'+i">
            <div class="box-split"></div>
            <div v-if="i==0" class="box2-title-text">实习/工作经历</div>
            <div class="box2">
                <van-field v-model="item.Company" maxlength="100" required label="企业名称" placeholder="请输入企业名称" />
                <van-field v-model="item.Title" maxlength="100" required label="所任职位" placeholder="请输入所任职位" />
                <van-field v-model="item.StartDate" required label="开始时间" placeholder="请选择开始时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click.native="showStartDatePopup($event,item)" />
                <van-field v-model="item.EndDate" required label="结束时间" placeholder="请选择结束时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click.native="showEndDatePopup($event,item)" />
                <van-field v-model="item.Summary" maxlength="500" required label="工作描述" class="textarea" type="textarea" rows="5" placeholder="请输入工作描述" />
            </div>
          <template v-if="postion.targetId=='1004'">
            <div v-if="resumeDetail.ExperienceInfo.length>1 && i!=resumeDetail.ExperienceInfo.length-1" class="box2-btns">
              <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelJob($event,i)">
                删除工作经历
              </van-button>
            </div>
            <div v-if="i==resumeDetail.ExperienceInfo.length-1" class="box2-btns">
              <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelJob($event,i)">
                删除工作经历
              </van-button>
              <div style="width:12px;"/>
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddJob">
                添加工作经历
              </van-button>
            </div>
          </template>
          <template v-else>
            <div v-if="resumeDetail.ExperienceInfo.length==1" class="box2-btns">
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddJob">
                添加工作经历
              </van-button>
            </div>
            <div v-if="resumeDetail.ExperienceInfo.length>1 && i!=resumeDetail.ExperienceInfo.length-1" class="box2-btns">
              <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelJob($event,i)">
                删除工作经历
              </van-button>
            </div>
            <div v-if="resumeDetail.ExperienceInfo.length>1 && i==resumeDetail.ExperienceInfo.length-1" class="box2-btns">
              <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelJob($event,i)">
                删除工作经历
              </van-button>
              <div style="width:12px;"/>
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddJob">
                添加工作经历
              </van-button>
            </div>
          </template>
        </div>
        <div v-if="postion.targetId=='1004' && (!resumeDetail.ExperienceInfo || resumeDetail.ExperienceInfo.length==0)">
          <div class="box-split"></div>
          <div class="box2-title-text">实习/工作经历</div>
          <div class="box2">
            <div class="box2-btns">
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddJob">
                添加工作经历
              </van-button>
            </div>
          </div>
        </div>
        <div style="height: 1px"></div>
        <div v-for="(item,i) in resumeDetail.ProjectInfo" :key="'pro'+i">
            <div class="box-split"></div>
            <div v-if="i==0" class="box2-title-text">项目经历</div>
            <div class="box2">
                <van-field v-model="item.ProjectName" maxlength="100" required label="项目名称" placeholder="请输入项目名称" />
                <van-field v-model="item.Title" maxlength="100" required label="项目角色" placeholder="请输入项目角色" />
                <van-field v-model="item.StartDate" required label="开始时间" placeholder="请选择开始时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click.native="showStartDatePopup($event,item)" />
                <van-field v-model="item.EndDate" required label="结束时间" placeholder="请选择结束时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click.native="showEndDatePopup($event,item)" />
                <van-field v-model="item.ProjectDescription" maxlength="1000" required label="项目描述" class="textarea" type="textarea" rows="5" placeholder="请输入项目描述" />
<!--                <van-field v-model="item.Responsibilities" required label="项目职责" class="textarea" type="textarea" rows="5" placeholder="请输入项目职责" />-->
            </div>
            <div v-if="resumeDetail.ProjectInfo.length>1 && i!=resumeDetail.ProjectInfo.length-1" class="box2-btns">
              <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelPro($event,i)">
                删除项目经历
              </van-button>
            </div>
            <div v-if="i==resumeDetail.ProjectInfo.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelPro($event,i)">
              删除项目经历
            </van-button>
            <div style="width:12px;"/>
            <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddPro">
              添加项目经历
            </van-button>
          </div>
        </div>
        <div v-if="!resumeDetail.ProjectInfo || resumeDetail.ProjectInfo.length==0">
            <div class="box-split"></div>
            <div class="box2-title-text">项目经历</div>
            <div class="box2">
                <div class="box2-btns">
                    <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddPro">
                        添加项目经历
                    </van-button>
                </div>
            </div>
        </div>
        <div style="height: 1px"></div>
        <div v-for="(item,i) in resumeDetail.worksInfo" :key="'work'+i">
          <div class="box-split"></div>
          <div v-if="i==0" class="box2-title-text">作品</div>
          <div class="box2">
            <van-field v-model="item.url" maxlength="1000" required label="作品链接" placeholder="请输入作品链接" />
            <van-field v-model="item.description" maxlength="500" label="作品描述" class="textarea" type="textarea" rows="5" placeholder="请输入作品描述" />
          </div>
          <div v-if="resumeDetail.worksInfo.length>1 && i!=resumeDetail.worksInfo.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelWorks($event,i)">
              删除作品
            </van-button>
          </div>
          <div v-if="i==resumeDetail.worksInfo.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelWorks($event,i)">
              删除作品
            </van-button>
            <div style="width:12px;"/>
            <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddWorks">
              添加作品
            </van-button>
          </div>
        </div>
        <div v-if="!resumeDetail.worksInfo || resumeDetail.worksInfo.length==0">
          <div class="box-split"></div>
          <div class="box2-title-text">作品</div>
          <div class="box2">
            <div class="box2-btns">
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddWorks">
                添加作品
              </van-button>
            </div>
          </div>
        </div>
        <div style="height: 1px"></div>
        <div v-for="(item,i) in resumeDetail.contestInfo" :key="'cont'+i">
          <div class="box-split"></div>
          <div v-if="i==0" class="box2-title-text">竞赛</div>
          <div class="box2">
            <van-field v-model="item.name" maxlength="100" required label="竞赛名称" placeholder="请输入竞赛名称" />
            <van-field v-model="item.description" maxlength="500" label="说明" class="textarea" type="textarea" rows="5" placeholder="请输入竞赛描述" />
          </div>
          <div v-if="resumeDetail.contestInfo.length>1 && i!=resumeDetail.contestInfo.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelCont($event,i)">
              删除竞赛
            </van-button>
          </div>
          <div v-if="i==resumeDetail.contestInfo.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelCont($event,i)">
              删除竞赛
            </van-button>
            <div style="width:12px;"/>
            <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddCont">
              添加竞赛
            </van-button>
          </div>
        </div>
        <div v-if="!resumeDetail.contestInfo || resumeDetail.contestInfo.length==0">
          <div class="box-split"></div>
          <div class="box2-title-text">竞赛</div>
          <div class="box2">
            <div class="box2-btns">
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddCont">
                添加竞赛
              </van-button>
            </div>
          </div>
        </div>
        <div style="height: 1px"></div>
        <div v-for="(item,i) in resumeDetail.certificateInfo" :key="'cert'+i">
          <div class="box-split"></div>
          <div v-if="i==0" class="box2-title-text">证书</div>
          <div class="box2">
            <van-field v-model="item.name" maxlength="100" required label="证书名称" placeholder="请输入证书名称" />
            <van-field v-model="item.description" maxlength="500" label="说明" class="textarea" type="textarea" rows="5" placeholder="请输入证书描述" />
          </div>
          <div v-if="resumeDetail.certificateInfo.length>1 && i!=resumeDetail.certificateInfo.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelCert($event,i)">
              删除证书
            </van-button>
          </div>
          <div v-if="i==resumeDetail.certificateInfo.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelCert($event,i)">
              删除证书
            </van-button>
            <div style="width:12px;"/>
            <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddCert">
              添加证书
            </van-button>
          </div>
        </div>
        <div v-if="!resumeDetail.certificateInfo || resumeDetail.certificateInfo.length==0">
          <div class="box-split"></div>
          <div class="box2-title-text">证书</div>
          <div class="box2">
            <div class="box2-btns">
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddCert">
                添加证书
              </van-button>
            </div>
          </div>
        </div>
        <div style="height: 1px"></div>
        <div v-for="(item,i) in resumeDetail.LanguagesSkills" :key="'lang'+i">
          <div class="box-split"></div>
          <div v-if="i==0" class="box2-title-text">语言能力</div>
          <div class="box2">
            <van-field v-model="item.langtype" required label="语言种类" placeholder="请选择语言种类" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event,item,'lang')" />
            <template v-if="item.langtype=='英语'">
            <van-field v-model="item.grade" required label="等级　　" placeholder="请选择等级" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event,item,'grade')" />
            <van-field v-model="item.Score" required label="分数　　" placeholder="请输入分数" />
            </template>
            <template v-else>
            <van-field v-model="item.Languages" maxlength="100" required label="语言　　" placeholder="请输入语言" />
            <van-field v-model="item.Skills" required label="精通程度" placeholder="请选择精通程度" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event,item,'skill')" />
            </template>
          </div>
          <div v-if="resumeDetail.LanguagesSkills.length>1 && i!=resumeDetail.LanguagesSkills.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelLang($event,i)">
              删除语言
            </van-button>
          </div>
          <div v-if="i==resumeDetail.LanguagesSkills.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelLang($event,i)">
              删除语言
            </van-button>
            <div style="width:12px;"/>
            <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddLang">
              添加语言
            </van-button>
          </div>
        </div>
        <div v-if="!resumeDetail.LanguagesSkills || resumeDetail.LanguagesSkills.length==0">
          <div class="box-split"></div>
          <div class="box2-title-text">语言</div>
          <div class="box2">
            <div class="box2-btns">
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddLang">
                添加语言
              </van-button>
            </div>
          </div>
        </div>
        <div class="xieyi">
          <van-checkbox v-model="checked">我承诺所填简历真实可信，并对由于提供虚假信息而引发的结果承担相应的法律责任，如有虚假，责任自负。</van-checkbox>

        </div>
        <div style="height: 114px;"></div>
        <SafeBottom></SafeBottom>
      </div>
      <div class="bottom-btns">
          <button class="bottom-btn-default" @click="showPCPopup">电脑投递</button>
          <div style="width:16px"></div>
          <button class="bottom-btn" @click="deliveryPostion">立即投递</button>
      </div>
      <Footer></Footer>
      <van-popup v-model="showStartDatePicker" round position="bottom">
          <van-datetime-picker
                  v-model="currentItem.StartDateTime"
                  type="date"
                  title=""
                  :min-date="minDate"
                  :max-date="maxDate"
                  :formatter="formatterDate"
                  @change="changeStartDate"
                  @confirm="onConfirmStartDate"
                  @cancel="showStartDatePicker = false"
          />
      </van-popup>
      <van-popup v-model="showEndDatePicker" round position="bottom">
<!--          <van-datetime-picker-->
<!--                  v-model="currentItem.EndDateTime"-->
<!--                  type="date"-->
<!--                  title=""-->
<!--                  :min-date="minDate"-->
<!--                  :max-date="maxDate"-->
<!--                  :formatter="formatterDate"-->
<!--                  showToNow-->
<!--                  @change="changeEndDate"-->
<!--                  @confirm="onConfirmEndDate"-->
<!--                  @cancel="showEndDatePicker = false"-->
<!--          />-->
        <VueDatetimePicker
            v-model="currentItem.EndDateTime"
            type="date"
            title=""
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatterDate"
            showToNow
            @change="changeEndDate"
            @confirm="onConfirmEndDate"
            @cancel="showEndDatePicker = false"
        />
      </van-popup>
      <van-popup v-model="showPicker" round position="bottom">
          <van-picker
                  :default-index="pickerIndex"
                  title=""
                  show-toolbar
                  :columns="pickerOptions"
                  value-key="dict_name"
                  @cancel="showPicker = false"
                  @confirm="onConfirm"
          />
      </van-popup>
      <van-popup v-model="showPCPicker" round closeable position="bottom" class="popup">
          <div class="popup-title">
            去电脑上投递
          </div>
          <div class="popup-input">
            <van-field
                v-model="sendEmail"
                left-icon="envelop-o"
                placeholder="请输入邮箱"
            />
          </div>
          <div class="popup-btns">
            <button class="bottom-btn-default" v-clipboard:copy="postion.url" v-clipboard:success="onCopy" v-clipboard:error="onCopyError">复制链接</button>
            <div style="width:16px"></div>
            <button class="bottom-btn" @click="sendUrl">发送链接至邮箱</button>
          </div>
      </van-popup>
      <van-dialog v-model="showPreview" title="" width="98%" className="dialog-preview" :show-cancel-button="false" :show-confirm-button="false">
          <iframe id="iframePreview" :src="onlineUri?onlineUri:'about:blank'" style="width:100%;height:100vh;border:none;" ></iframe>
          <div style="position: absolute;right: 20px;bottom: 20px; background-color: rgba(255,255,255,.7); width: 40px;height: 40px; border-radius: 40px; ">
              <van-icon name="close" @click="onCancelPreview" size="40px" color="#3A5FFF" />
          </div>
      </van-dialog>
      <Dialog :visible="showDeliverOk" :call-back="deliveryOk" cancel-button-text="其他职位" confirm-button-text="招聘首页">
          <img :src="require('@/assets/ok.png')" style="width: 40px;height: 40px;" />
          <div style="margin-top:12px;font-family: PingFangSC-Medium;font-size: 14px;color: #20253F;text-align: center;line-height: 18px;font-weight: 500;">
            职位申请成功
          </div>
          <div style="margin-top:12px;font-family: PingFangSC-Regular;font-size: 12px;color: #666D7F;text-align: center;line-height: 14px;font-weight: 400;">
            立即查看<a style="color: #206CFE;" v-on:click="gotoResumeProcess">招聘进度</a>
          </div>
        </Dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import {
  Toast,
  Uploader,
  Field,
  DatetimePicker,
  Popup,
  Picker,
  Icon,
  Checkbox,
  Tag,
  Button
} from 'vant';
import moment from 'moment';
import Utils from '../utils/Utils';
import Urls from '../utils/Urls';
import Request from '../utils/Request';
import validator from '../validator/validator';
import '@vant/touch-emulator';
import Header from "./Header1";
import Footer from "./Footer";
import VueClipboard from 'vue-clipboard2';
import Dialog from "./Dialog/Dialog1";
import wx from "weixin-js-sdk";
import VueDatetimePicker from "./DatetimePicker/DatetimePicker";
import SafeBottom from "./SafeBottom";
Vue.use(Uploader);
Vue.use(Field);
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(Picker);
Vue.use(Icon);
Vue.use(Checkbox);
Vue.use(Tag);
Vue.use(Button);
Vue.use(VueClipboard);
export default {
    name: 'Delivery',
    components:{
      SafeBottom,
      Header,
      Footer,
      Dialog,
      VueDatetimePicker
    },
    props: {
        msg: String
    },
    data() {
      return {
        app:'',
        loading:false,
        maxFile:8*1024*1024,
        accept:'.doc,.pdf,.docx,application/*',
        postion:{
        },
        sendEmail:'',
        fileIcon: 'word',
        onlineUri:'',
        resumePath:'',
        knowType:'',
        knowSource:'',
        knowTypeName:'',
        knowSourceName:'',
        resumeDetail:{
          Name:"",
          Mobile:"",
          Email:"",
          Sex:"",
          EducationInfo:[{
              School:"",
              Speciality:"",
              StartDate:"",
              EndDate:"",
              Education:""
          }],
          ExperienceInfo:[],
          ProjectInfo:[],
          certificateInfo:[],
          LanguagesSkills:[],
          worksInfo:[],
          internshipInfo:[],
          contestInfo:[],
        },
        checked:false,
        sexList:[{dict_value:'男',dict_name:'男'},
          {dict_value:'女',dict_name:'女'}],
        eduList:[],
        studytypeList:[{dict_value:'是',dict_name:'是'},
          {dict_value:'否',dict_name:'否'}],
        profrankList:[],
        contestList:[],
        languageList:[],
        languagegradeList:[],
        languageskillList:[],
        expectedjobList:[],
        knowTypeList:[],
        knowSourceList:[],
        showStartDatePicker: false,
        showEndDatePicker: false,
        showPicker:false,
        pickerOptions:[],
        pickerType:'',
        pickerIndex:0,
        minDate: new Date(1950, 0, 1),
        maxDate: new Date(),
        currentItem:{
            EndDateTime:new Date(),
            StartDateTime:new Date(),
        },
        showPreview:false,
        showPCPicker:false,
        showDeliverOk:false,
        deliveryResumeId:'',
      };
    },
    mounted:function(){
        this.app=Utils.getApp();
        this.getInit();
        this.getDeliveryKnowSource();
        this.getPostion();
        //this.getUserInfo();
    },
    methods: {
        getInit()
        {
          let that=this;
          Request.request(Urls.initialData).then((data)=>{
              if(data)
              {
                that.eduList=data.edu;
                that.profrankList=data.profrank;
                that.contestList=data.competitionname;
                that.languageList=data.language;
                that.languagegradeList=data.englishlevel;
                that.languageskillList=data.languagelevel;
                that.knowTypeList=data.knowTypeList;
              }
          });
        },
        getKnowList(){
            if(!this.knowType)
            {
              this.knowSourceList=[];
              return;
            }
            let that=this;
            Request.request(Urls.getKnowList,{parentcode:this.knowType}).then((data)=>{
                that.knowSourceList=data || [];
            });
        },
        getPostion() {
          let that=this;
          Toast.loading({
            duration: 0,
            forbidClick: true,
          });
          Request.request(Urls.getPositionDetail, { positionId:this.$route.query.id }).then(data => {
            Toast.clear();
            if (data) {
              let expectedjobList=[];
              if(data.tags)
              {
                data.tags.split('/').forEach(tag=>{
                  expectedjobList.push({dict_value:tag,dict_name:tag});
                });
              }
              that.expectedjobList=expectedjobList;
              that.postion = data;
            }
            that.getUserInfo();
          });
        },
        getDeliveryKnowSource() {
          let that=this;
          Request.request(Urls.getDeliveryKnowSource, { positionId:this.$route.query.id }).then(data => {
            if (data) {
              that.knowType=data.knowType;
              that.knowSource=data.knowSource;
              that.knowTypeName=data.knowTypeName;
              that.knowSourceName=data.knowSourceName;
              that.getKnowList();
            }
          });
        },
        getUserInfo(){
          let that=this;
          this.loading=true;
          Request.request(Urls.getUserInfo).then((data)=>{
            this.loading=false;
            if(data)
            {
              that.fileIcon=Utils.getFileIcon(data.resumePath);
              that.onlineUri=data.onlineUri;
              that.resumePath=data.resumePath;
              if(data.resumeDetail) {
                let resumeDetail=JSON.parse(data.resumeDetail);
                if(resumeDetail.educationInfo && resumeDetail.educationInfo instanceof Array) {
                  delete resumeDetail.educationInfo;
                }
                if(resumeDetail.experienceInfo && resumeDetail.experienceInfo instanceof Array) {
                  delete resumeDetail.experienceInfo;
                }
                if(resumeDetail.projectInfo && resumeDetail.projectInfo instanceof Array) {
                  delete resumeDetail.projectInfo;
                }
                if(resumeDetail.trainingInfo && resumeDetail.trainingInfo instanceof Array) {
                  delete resumeDetail.trainingInfo;
                }
                that.resumeDetail ={...that.resumeDetail,...resumeDetail};
                // if(that.postion.targetId=='1004' && that.resumeDetail.expectedJobFunction && !that.expectedjobList.find(tag=>{return tag.dict_value==that.resumeDetail.expectedJobFunction; }))
                // {
                //   that.resumeDetail.expectedJobFunction='';
                // }
                if(that.resumeDetail.Email)
                {
                  that.sendEmail=that.resumeDetail.Email;
                }
                if(!(that.resumeDetail.EducationInfo && that.resumeDetail.EducationInfo.length>0))
                {
                  that.resumeDetail.EducationInfo=[{
                    School:"",
                    Speciality:"",
                    StartDate:"",
                    EndDate:"",
                    Education:""
                  }];
                }
                if(!(that.resumeDetail.ExperienceInfo && that.resumeDetail.ExperienceInfo.length>0))
                {
                  that.resumeDetail.ExperienceInfo=that.postion.targetId=='1004'?[]:[{
                    Company: "",
                    Title: "",
                    StartDate: "",
                    EndDate: "",
                    Summary: ""
                  }];
                }
                if(!(that.resumeDetail.ProjectInfo))
                {
                  that.resumeDetail.ProjectInfo=[];
                }
                if(!(that.resumeDetail.certificateInfo))
                {
                  that.resumeDetail.certificateInfo=[];
                }
                if(!(that.resumeDetail.LanguagesSkills))
                {
                  that.resumeDetail.LanguagesSkills=[];
                }
                else
                {
                  that.resumeDetail.LanguagesSkills.forEach(l=>{
                    l.langtype=l.Languages.indexOf('英语')!=-1?'英语':'其他';
                  });
                }
                if(!(that.resumeDetail.worksInfo))
                {
                  that.resumeDetail.worksInfo=[];
                }
                if(!(that.resumeDetail.internshipInfo))
                {
                  that.resumeDetail.internshipInfo=[];
                }
                if(!(that.resumeDetail.contestInfo))
                {
                  that.resumeDetail.contestInfo=[];
                }
              }
            }
          });
        },
        setPreviewHeight()
        {
          document.getElementById("iframePreview").style.height= document.getElementsByClassName("van-dialog__content").offsetHeight+"px";
        },
        onCancelPreview()
        {
            this.showPreview=false;
        },
        onPreview()
        {
            this.showPreview=true;
            //window.open(this.onlineUri);
        },
        onBeforeReadFile(file) {
            console.log(file)
            let that=this;
            that.name=null;
            if(!file.type)
            {
                Utils.getFileType(file).then(type=>{
                    if(type)
                    {
                        that.name=file.name+'.'+type;
                    }
                    else
                    {
                        Toast('请上传 pdf,docx,doc ');
                        return false;
                    }
                });
            }
            else {
                let suf = Utils.getFileSuffix(file.name);
                if (suf != 'doc' && suf != 'docx' && suf != 'pdf') {
                    Toast('请上传 pdf,docx,doc ');
                    return false;
                }
            }
            if(file.size>this.maxFile)
            {
                Toast('上传文件不能超过8M');
                return false;
            }
            return true;
        },
        onAfterReadFile(file, detail) {
            console.log(file)
            console.log(detail)
            let that=this;
            let upfile=file.file;
            if(that.name)
            {
                upfile=new File([file.file],that.name);
            }
            Toast.loading({
                message: '正在上传',
                duration: 0,
                forbidClick: true,
            });
            Request.requestFile(Urls.uploadResumeFile,upfile).then((data)=>{
                console.log(data);
                Toast.clear();
                if(data)
                {
                  that.fileIcon=Utils.getFileIcon(data.resumePath);
                  that.resumePath=data.resumePath;
                  if(data.resumeDetail) {
                      if(that.onlineUri)
                      {
                          that.$Dialog.confirm({
                              title: '提示',
                              message: '是否根据新的简历更新在线简历内容？',
                          })
                          .then(() => {
                              let resumeDetail=data.resumeDetail;
                              if(resumeDetail.educationInfo && resumeDetail.educationInfo instanceof Array) {
                                delete resumeDetail.educationInfo;
                              }
                              if(resumeDetail.experienceInfo && resumeDetail.experienceInfo instanceof Array) {
                                delete resumeDetail.experienceInfo;
                              }
                              if(resumeDetail.projectInfo && resumeDetail.projectInfo instanceof Array) {
                                delete resumeDetail.projectInfo;
                              }
                              if(resumeDetail.trainingInfo && resumeDetail.trainingInfo instanceof Array) {
                                delete resumeDetail.trainingInfo;
                              }
                              that.resumeDetail ={...that.resumeDetail,...resumeDetail};
                              // if(that.postion.targetId=='1004' && that.resumeDetail.expectedJobFunction && !that.expectedjobList.find(tag=>{return tag.dict_value==that.resumeDetail.expectedJobFunction; }))
                              // {
                              //   that.resumeDetail.expectedJobFunction='';
                              // }
                              if(that.resumeDetail.Email)
                              {
                                that.sendEmail=that.resumeDetail.Email;
                              }
                              if(!(that.resumeDetail.EducationInfo && that.resumeDetail.EducationInfo.length>0))
                              {
                                  that.resumeDetail.EducationInfo=[{
                                      School:"",
                                      Speciality:"",
                                      StartDate:"",
                                      EndDate:"",
                                      Education:""
                                  }];
                              }
                              if(!(that.resumeDetail.ExperienceInfo && that.resumeDetail.ExperienceInfo.length>0))
                              {
                                  that.resumeDetail.ExperienceInfo=that.postion.targetId=='1004'?[]:[{
                                      Company: "",
                                      Title: "",
                                      StartDate: "",
                                      EndDate: "",
                                      Summary: ""
                                  }];
                              }
                              if(!(that.resumeDetail.ProjectInfo))
                              {
                                  that.resumeDetail.ProjectInfo=[];
                              }
                              if(!(that.resumeDetail.certificateInfo))
                              {
                                that.resumeDetail.certificateInfo=[];
                              }
                              if(!(that.resumeDetail.LanguagesSkills))
                              {
                                that.resumeDetail.LanguagesSkills=[];
                              }
                              else
                              {
                                that.resumeDetail.LanguagesSkills.forEach(l=>{
                                    l.langtype=l.Languages.indexOf('英语')!=-1?'英语':'其他';
                                });
                              }
                              if(!(that.resumeDetail.worksInfo))
                              {
                                that.resumeDetail.worksInfo=[];
                              }
                              if(!(that.resumeDetail.internshipInfo))
                              {
                                that.resumeDetail.internshipInfo=[];
                              }
                              if(!(that.resumeDetail.contestInfo))
                              {
                                that.resumeDetail.contestInfo=[];
                              }
                          })
                          .catch(() => {
                              // on cancel
                          });
                      }
                      else
                      {
                          let resumeDetail=data.resumeDetail;
                          if(resumeDetail.educationInfo && resumeDetail.educationInfo instanceof Array) {
                            delete resumeDetail.educationInfo;
                          }
                          if(resumeDetail.experienceInfo && resumeDetail.experienceInfo instanceof Array) {
                            delete resumeDetail.experienceInfo;
                          }
                          if(resumeDetail.projectInfo && resumeDetail.projectInfo instanceof Array) {
                            delete resumeDetail.projectInfo;
                          }
                          if(resumeDetail.trainingInfo && resumeDetail.trainingInfo instanceof Array) {
                            delete resumeDetail.trainingInfo;
                          }
                          that.resumeDetail ={...that.resumeDetail,...resumeDetail};
                          // if(that.postion.targetId=='1004' && that.resumeDetail.expectedJobFunction && !that.expectedjobList.find(tag=>{return tag.dict_value==that.resumeDetail.expectedJobFunction; }))
                          // {
                          //   that.resumeDetail.expectedJobFunction='';
                          // }
                          if(that.resumeDetail.Email)
                          {
                            that.sendEmail=that.resumeDetail.Email;
                          }
                          if(!(that.resumeDetail.EducationInfo && that.resumeDetail.EducationInfo.length>0))
                          {
                            that.resumeDetail.EducationInfo=[{
                                  School:"",
                                  Speciality:"",
                                  StartDate:"",
                                  EndDate:"",
                                  Education:""
                            }];
                          }
                          if(!(that.resumeDetail.ExperienceInfo && that.resumeDetail.ExperienceInfo.length>0))
                          {
                            that.resumeDetail.ExperienceInfo=that.postion.targetId=='1004'?[]:[{
                                  Company: "",
                                  Title: "",
                                  StartDate: "",
                                  EndDate: "",
                                  Summary: ""
                            }];
                          }
                          if(!(that.resumeDetail.ProjectInfo))
                          {
                            that.resumeDetail.ProjectInfo=[];
                          }
                          if(!(that.resumeDetail.certificateInfo))
                          {
                            that.resumeDetail.certificateInfo=[];
                          }
                          if(!(that.resumeDetail.LanguagesSkills))
                          {
                            that.resumeDetail.LanguagesSkills=[];
                          }
                          if(!(that.resumeDetail.worksInfo))
                          {
                            that.resumeDetail.worksInfo=[];
                          }
                          if(!(that.resumeDetail.internshipInfo))
                          {
                            that.resumeDetail.internshipInfo=[];
                          }
                          if(!(that.resumeDetail.contestInfo))
                          {
                            that.resumeDetail.contestInfo=[];
                          }
                      }
                  }
                  that.onlineUri=data.onlineUri;
                }
            })
        },
        delFile()
        {
          let that=this;
          this.$Dialog.confirm({
            title: '提示',
            message: '确认删除吗？',
          })
              .then(() => {
                that.resumePath='';
                that.onlineUri='';
              })
              .catch(() => {
                // on cancel
              });
        },

        formatterDate(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            }
            return `${val}日`;
        },
        changeStartDate(picker){
            let date=picker.getValues().join('-').replace('年','').replace('月','').replace('日','');
            //console.log(date)
            if(date.indexOf('至今')!=-1)
            {
                return;
            }
            if(this.currentItem.EndDate)
            {
                if(moment(date,'YYYY-MM-DD').isAfter(moment(this.currentItem.EndDate,'YYYY-MM-DD')))
                {
                    if(this.currentItem.StartDate) {
                        console.log('setvalues currentItem',moment(this.currentItem.StartDate).format('YYYY年-MM月-DD日'))
                        picker.setValues(moment(this.currentItem.StartDate).format('YYYY年-MM月-DD日').split('-'));
                    }
                    else
                    {
                        console.log('setvalues ',moment().format('YYYY年-MM月-DD日'))
                        picker.setValues(moment().format('YYYY年-MM月-DD日').split('-'));
                    }
                    Toast('不能大于结束时间');
                    //return false;
                }
            }
        },
        changeEndDate(picker){
            let date=picker.getValues().join('-').replace('年','').replace('月','').replace('日','');
            //console.log(date)
            if(date.indexOf('至今')!=-1)
            {
                return;
            }
            if(this.currentItem.StartDate)
            {
                if(moment(date,'YYYY-MM-DD').isBefore(moment(this.currentItem.StartDate,'YYYY-MM-DD')))
                {
                    if(this.currentItem.EndDate)
                    {
                      console.log('setvalues currentItem',moment(this.currentItem.EndDate).format('YYYY年-MM月-DD日'))
                        picker.setValues(moment(this.currentItem.EndDate).format('YYYY年-MM月-DD日').split('-'));
                    }
                    else
                    {
                        console.log('setvalues',moment().format('YYYY年-MM月-DD日'))
                        picker.setValues(moment().format('YYYY年-MM月-DD日').split('-'));
                    }
                    Toast('不能小于开始时间');
                    //return false;
                }
            }
        },
        showStartDatePopup(e,item) {
            this.showStartDatePicker = true;
            this.currentItem=item;
            if(item.startDate!=undefined)
            {
              item.StartDate=item.startDate;
            }
            if(item.StartDate)
            {
                item.StartDateTime=moment(item.StartDate,'YYYY-MM-DD').toDate();
            }
            else
            {
                item.StartDateTime=moment().toDate();
            }
        },
        onConfirmStartDate(date){
            this.showStartDatePicker = false;
            console.log(date)
            this.currentItem.StartDateTime=date;
            this.currentItem.StartDate=moment(date).format('YYYY-MM-DD');
            if(this.currentItem.startDate!=undefined)
            {
              this.currentItem.startDate=moment(date).format('YYYY-MM-DD');
            }
        },
        showEndDatePopup(e,item) {
            this.showEndDatePicker = true;
            this.currentItem=item;
            if(item.endDate!=undefined)
            {
              item.EndDate=item.endDate;
            }
            if(item.EndDate)
            {
                item.EndDateTime=item.EndDate=='至今'?item.EndDate:moment(item.EndDate,'YYYY-MM-DD').toDate();
            }
            else
            {
                item.EndDateTime=moment().toDate();
            }
        },
        onConfirmEndDate(date){
            this.showEndDatePicker = false;
            console.log('onConfirmEndDate',date)
            this.currentItem.EndDateTime=date;
            this.currentItem.EndDate = date == '至今' ? date : moment(date).format('YYYY-MM-DD');
            console.log('this.currentItem.EndDateTime',date)
            if(this.currentItem.endDate!=undefined)
            {
              this.currentItem.endDate = date == '至今' ? date : moment(date).format('YYYY-MM-DD');
            }
        },

        showPopup(e,item,type) {
            this.showPicker = true;
            this.currentItem=item;
            this.pickerType=type;
            switch (this.pickerType)
            {
              case "job":
                this.pickerOptions=this.expectedjobList;
                this.pickerIndex=this.getPickItemIndex(this.currentItem.expectedJob);
                break;
              case "sex":
                this.pickerOptions=this.sexList;
                this.pickerIndex=this.getPickItemIndex(this.currentItem.Sex);
                break;
              case "edu":
                this.pickerOptions=this.eduList;
                this.pickerIndex=this.getPickItemIndex(this.currentItem.Education);
                break;
              case "study":
                this.pickerOptions=this.studytypeList;
                this.pickerIndex=this.getPickItemIndex(this.currentItem.studyType);
                break;
              case "prof":
                this.pickerOptions=this.profrankList;
                this.pickerIndex=this.getPickItemIndex(this.currentItem.professionRanking);
                break;
              case "contest":
                this.pickerOptions=this.contestList;
                this.pickerIndex=this.getPickItemIndex(this.currentItem.name);
                break;
              case "lang":
                this.pickerOptions=this.languageList;
                this.pickerIndex=this.getPickItemIndex(this.currentItem.langtype);
                break;
              case "grade":
                this.pickerOptions=this.languagegradeList;
                this.pickerIndex=this.getPickItemIndex(this.currentItem.grade);
                break;
              case "skill":
                this.pickerOptions=this.languageskillList;
                this.pickerIndex=this.getPickItemIndex(this.currentItem.Skills);
                break;
              case "knowType":
                this.pickerOptions=this.knowTypeList;
                this.pickerIndex=this.getPickItemIndex(this.currentItem);
                break;
              case "knowSource":
                this.pickerOptions=this.knowSourceList;
                this.pickerIndex=this.getPickItemIndex(this.currentItem);
                break;
            }
        },
        getPickItemIndex(text)
        {
          let index=this.pickerOptions.findIndex(n=>n.dict_name==text);
          return index==-1?0:index;
        },
        onConfirm(value)
        {
            this.showPicker = false;
            console.log(value)
            switch (this.pickerType)
            {
              case "job":
                this.currentItem.expectedJob=value.dict_name;
                break;
              case "sex":
                this.currentItem.Sex=value.dict_name;
                break;
              case "edu":
                this.currentItem.Education=value.dict_name;
                break;
              case "study":
                this.currentItem.studyType=value.dict_name;
                break;
              case "prof":
                this.currentItem.professionRanking=value.dict_name;
                break;
              case "contest":
                this.currentItem.name=value.dict_name;
                break;
              case "lang":
                this.currentItem.langtype=value.dict_name;
                if(this.currentItem.langtype=='英语')
                {
                  this.currentItem.Languages = this.currentItem.langtype;
                  this.currentItem.grade='';
                  this.currentItem.Score='';
                }
                else
                {
                  this.currentItem.Languages='';
                  this.currentItem.Skills='';
                }
                break;
              case "grade":
                this.currentItem.grade=value.dict_name;
                break;
              case "skill":
                this.currentItem.Skills=value.dict_name;
                break;
              case "knowType":
                if(this.knowType==value.dict_value)
                {
                  return;
                }
                this.knowType=value.dict_value;
                this.knowTypeName=value.dict_name;
                this.knowSource="";
                this.knowSourceName="";
                this.getKnowList();
                break;
              case "knowSource":
                this.knowSource=value.dict_value;
                this.knowSourceName=value.dict_name;
                break;
            }
        },
        knowSourceIsText()
        {
          if(this.knowSourceList && this.knowSourceList.length>0 && this.knowSourceList.find(n=>n.dict_name=='text')) {
            return true;
          }
          return false;
        },
        knowSourceTextLabel()
        {
          let label="内推码或推荐人工号";
          if(this.knowSourceList && this.knowSourceList.length>0 && this.knowSourceList.find(n=>n.dict_value.indexOf('other')!=-1)) {
            label="其他来源";
          }
          return label;
        },

        onAddEdu()
        {
            this.resumeDetail.EducationInfo.push({
                School:"",
                Speciality:"",
                StartDate:"",
                EndDate:"",
                Education:""
            });
        },
        onDelEdu(e,i)
        {
            let that=this;
            if(this.resumeDetail.EducationInfo && this.resumeDetail.EducationInfo.length>1) {
                this.$Dialog.confirm({
                    title: '提示',
                    message: '确认删除吗？',
                })
                    .then(() => {
                        // on confirm
                        that.resumeDetail.EducationInfo.splice(i, 1);
                    })
                    .catch(() => {
                        // on cancel
                    });
            }
            else
            {
                Toast('不能在删除了');
            }
        },

        onAddJob()
        {
            this.resumeDetail.ExperienceInfo.push({
                Company: "",
                Title: "",
                StartDate: "",
                EndDate: "",
                Summary: ""
            });
        },
        onDelJob(e,i)
        {
            let that=this;
            if(this.postion.targetId=='1004' || (this.resumeDetail.ExperienceInfo && this.resumeDetail.ExperienceInfo.length>1)) {
                this.$Dialog.confirm({
                    title: '提示',
                    message: '确认删除吗？',
                })
                    .then(() => {
                        // on confirm
                        that.resumeDetail.ExperienceInfo.splice(i, 1);
                    })
                    .catch(() => {
                        // on cancel
                    });
            }
            else
            {
                Toast('不能在删除了');
            }
        },

        onAddPro()
        {
            this.resumeDetail.ProjectInfo.push({
                ProjectName: "",
                StartDate: "",
                EndDate: "",
                ProjectDescription: "",
                Responsibilities: ""
            });
        },
        onDelPro(e,i)
        {
            let that=this;
            // if(this.resumeDetail.ProjectInfo && this.resumeDetail.ProjectInfo.length>1) {
                this.$Dialog.confirm({
                    title: '提示',
                    message: '确认删除吗？',
                })
                    .then(() => {
                        // on confirm
                        that.resumeDetail.ProjectInfo.splice(i, 1);
                    })
                    .catch(() => {
                        // on cancel
                    });
            // }
            // else
            // {
            //     Toast('不能在删除了');
            // }
        },

        onAddIntern()
        {
          this.resumeDetail.internshipInfo.push({
            company: "",
            title: "",
            startDate: "",
            endDate: "",
            jobDetail: ""
          });
        },
        onDelIntern(e,i)
        {
          let that=this;
          //if(this.resumeDetail.internshipInfo && this.resumeDetail.internshipInfo.length>1) {
            this.$Dialog.confirm({
              title: '提示',
              message: '确认删除吗？',
            })
            .then(() => {
              // on confirm
              that.resumeDetail.internshipInfo.splice(i, 1);
            })
            .catch(() => {
              // on cancel
            });
          // }
          // else
          // {
          //   Toast('不能在删除了');
          // }
        },

        onAddWorks()
        {
          this.resumeDetail.worksInfo.push({
            url: "",
            description: "",
          });
        },
        onDelWorks(e,i)
        {
          let that=this;
          //if(this.resumeDetail.worksInfo && this.resumeDetail.worksInfo.length>1) {
            this.$Dialog.confirm({
              title: '提示',
              message: '确认删除吗？',
            })
            .then(() => {
              // on confirm
              that.resumeDetail.worksInfo.splice(i, 1);
            })
            .catch(() => {
              // on cancel
            });
          // }
          // else
          // {
          //   Toast('不能在删除了');
          // }
        },

        onAddCont()
        {
          this.resumeDetail.contestInfo.push({
            name: "",
            description: "",
          });
        },
        onDelCont(e,i)
        {
          let that=this;
          //if(this.resumeDetail.contestInfo && this.resumeDetail.contestInfo.length>1) {
            this.$Dialog.confirm({
              title: '提示',
              message: '确认删除吗？',
            })
            .then(() => {
              // on confirm
              that.resumeDetail.contestInfo.splice(i, 1);
            })
            .catch(() => {
              // on cancel
            });
          // }
          // else
          // {
          //   Toast('不能在删除了');
          // }
        },

        onAddCert()
        {
          this.resumeDetail.certificateInfo.push({
            name: "",
            description: "",
          });
        },
        onDelCert(e,i)
        {
          let that=this;
          //if(this.resumeDetail.certificateInfo && this.resumeDetail.certificateInfo.length>1) {
            this.$Dialog.confirm({
              title: '',
              message: '确认删除吗？',
              theme: 'round-button',
            })
            .then(() => {
              // on confirm
              that.resumeDetail.certificateInfo.splice(i, 1);
            })
            .catch(() => {
              // on cancel
            });
          // }
          // else
          // {
          //   Toast('不能在删除了');
          // }
        },

        onAddLang()
        {
          this.resumeDetail.LanguagesSkills.push({
            langtype:"",
            Languages: "",
            Skills: "",
            grade:"",
            Score:"",
          });
        },
        onDelLang(e,i)
        {
          let that=this;
          //if(this.resumeDetail.LanguagesSkills && this.resumeDetail.LanguagesSkills.length>1) {
            this.$Dialog.confirm({
              title: '',
              message: '确认删除吗？',
            })
            .then(() => {
              // on confirm
              that.resumeDetail.LanguagesSkills.splice(i, 1);
            })
            .catch(() => {
              // on cancel
            });
          // }
          // else
          // {
          //   Toast('不能在删除了');
          // }
        },

        showPCPopup(){
          this.showPCPicker=true;
        },
        deliveryPostion()
        {
            let that=this;
            if(!this.checked)
            {
              Toast('请勾选页面底部正直诚信价值观承诺');
              return;
            }
            if(Utils.isBlank(this.resumePath))
            {
                Toast('请上传简历');
                return;
            }
            console.log(this.resumeDetail)
            if(this.postion.targetId=='1004' && !(this.knowType && this.knowSource))
            {
              Toast('请选择信息来源');
              return;
            }
            // if(this.postion.targetId=='1004' && !this.resumeDetail.expectedJob)
            // {
            //   Toast('请选择个人规划及发展方向');
            //   return;
            // }
            if(!validator.checkAllResume(this.resumeDetail))
            {
                return;
            }
            if(this.postion.targetId!='1004' && (!this.resumeDetail.ExperienceInfo || this.resumeDetail.ExperienceInfo.length==0))
            {
              Toast('请添写工作经历');
              return;
            }

            Request.request(Urls.checkDelivery, { positionId:this.postion.id }).then(data => {
              Toast.clear();
              if (data)
              {
                that.$Dialog.confirm({
                  title: '提示',
                  message: '您已经投递过'+(that.postion.targetId=='1004'?data.positionName+'，不能再投递其他职位':'了，不能在投递此职位了'),
                  cancelButtonText:''
                });
              }
              else
              {
                if(data===null)
                {
                    let body={
                        positionId:that.postion.id,
                        resumePath:that.resumePath,
                        edit:true,
                        resumeDetail:JSON.stringify(that.resumeDetail),
                        knowType:that.knowType,
                        knowSource:that.knowSource,
                        knowTypeName:that.knowTypeName,
                        knowSourceName:that.knowSourceName
                    }
                    Toast.loading({
                        duration: 0,
                        forbidClick: true,
                    });
                    Request.requestJson(Urls.deliveryPosition,body).then((resumeId)=>{
                        Toast.clear();
                        if(resumeId)
                        {
                            that.deliveryResumeId=resumeId;
                            that.showDeliverOk=true;
                        }
                    });
                }
              }
            });

        },
        deliveryOk(action){
            let url='';
            if(action)
            {
                url='index';
            }
            else
            {
              url='positionlist';
            }
            if(this.app=='WeiXinMini' && this.$route.query.minipage=='m')
            {
              Toast.loading({
                duration: 500,
                forbidClick: true,
              });
              wx.miniProgram.navigateTo({
                url: '/pages/m/child?url='+url,
                complete:()=>{
                  Toast.clear();
                }
              });
            }
            else
            {
              this.$router.push({path:'/'+url});
            }
        },
        gotoResumeProcess() {
          if(this.app=='WeiXinMini' && this.$route.query.minipage=='m')
          {
            Toast.loading({
              duration: 500,
              forbidClick: true,
            });
            wx.miniProgram.navigateTo({
              url: '/pages/m/child?url=deliverylist',
              complete:()=>{
                Toast.clear();
              }
            });
          }
          else
          {
              this.$router.push({path:'/deliverylist'});
          }
        },

        onCopy(e){
          Toast('复制内容: ' + e.text);
        },
        onCopyError(e){
          Toast('复制失败');
        },
        sendUrl(){
            let that=this;
            if(that.sendEmail)
            {
              Toast.loading({
                duration: 0,
                forbidClick: true,
              });
              Request.request(Urls.sendPositionUrl, {
                email:that.sendEmail,
                id:that.postion.id
              }).then((data)=>{
                Toast.clear();
                if(data)
                {
                  Toast('发送成功');
                }
                else
                {
                  Toast('发送失败');
                }
              });
            }
            else
            {
              Toast("请输入邮箱");
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .page
    {
      background-color: #F5F7FA;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .body{
      flex:1;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
    .header-box
    {
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 16px;
        margin-bottom: 20px;
    }
    .box-title-text
    {
        /*display: inline-block;*/
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #20253F;
        font-weight: 600;
    }
    .box-tags {
      margin-top: 8px;
      display: flex;
    }
    .van-tag{
      display: block;
      border-radius: 2px;
      padding:1px 3px;
      white-space: nowrap;
    }
    .van-tag+.van-tag
    {
      margin-left: 11px;
    }
    .ellipsis{
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .box-split
    {
        height: 0px;
        background-color: #F5F7FA;
    }

    .uploadbox
    {
      box-sizing: border-box;
      margin-left: 20px;
      margin-right: 20px;
      margin-top: 16px;
      margin-bottom: 16px;
      height: 163px;
      background-color: #FFFFFF;
      border: 1.5px dashed #DEE5F4;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .van-uploader>>> .van-uploader__input-wrapper{
      text-align: center;
    }
    .upload-icon{
      width: 38px;
      height: 45px;
    }
    .upload-text{
      margin-top: 16px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #20253F;
      line-height: 18px;
      font-weight: 500;
      text-align: center;
    }
    .upload-text-sub{
      margin-top: 8px;
      height: 14px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #666D7F;
      line-height: 14px;
      font-weight: 400;
      text-align: center;
    }
    .filebox
    {
        background-color: #FFFFFF;
        border-radius: 4px;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 16px;
        margin-bottom: 16px;
        padding: 10px 12px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .filebox-icon
    {
        width: 23px;
        height: 28px;
        vertical-align: middle;
    }
    .filebox-name
    {
        margin-left: 8px;
        flex: 1;
        height: 18px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #20253F;
        line-height: 18px;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .filebox-btns
    {
      height: 18px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #3A5FFF;
      line-height: 18px;
      font-weight: 400;
    }

    .box2
    {
        background-color: #FFFFFF;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 0;
        margin-bottom: 10px;
        border-radius: 6px;
        padding: 0 16px;
    }

    .box2-title{
      margin: 10px 20px;
      height: 18px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #20253F;
      line-height: 18px;
      font-weight: 500;
      display: flex;
      align-items: center;
    }
    .box2-title-icon{
      display: block;
      width: 3px;
      height: 13px;
      background:linear-gradient(to bottom,#206CFE 0%,#206CFE 50%,red 51%,red 100%);
      margin-right: 8px;
      margin-top: 1px;
    }
    .box2-title-text
    {
      margin: 10px 20px;
      height: 18px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #20253F;
      line-height: 18px;
      font-weight: 500;
    }
    .box2-title-text-sub{
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #111E36;
      line-height: 18px;
      font-weight: 400;
    }
    .van-cell{
      padding: 16px 0px;
      margin: 0px;
      border-bottom: 1px solid #F8F9FC;
      line-height:initial;
    }
    .van-cell:not(:last-child)::after {
        left: 0px;
        border-bottom: none;
    }
    .van-cell:last-child::after {
      border-bottom: none;
    }
    .van-cell:last-child
    {
      border-bottom: none;
    }
    .van-cell--required::before {
        position: inherit;
        left: 0px;
        font-family: PingFangSC-Regular;
        font-size: 15px;
        color: #F25058;
    }
    .van-field>>> .van-field__label
    {
        width: auto;
        margin-right: 30px;
    }
    .van-field>>> .van-field__label span
    {
      height: 16px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #20253F;
      line-height: 16px;
      font-weight: 400;
    }
    .van-field>>> .van-field__value input
    {
        height: 16px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #20253F;
        line-height: 16px;
        font-weight: 400;
    }
    .van-field>>> input::-webkit-input-placeholder,
    .van-field>>> input::-moz-placeholder,
    .van-field>>> input:-ms-input-placeholder,
    .van-field>>> input::-webkit-input-placeholder,
    .van-field>>> input::placeholder {
      height: 16px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #9499B0;
      line-height: 16px;
      font-weight: 400;
    }

    .textarea{
        display:block;
        padding-bottom: 0px;
        border-bottom: none !important;
    }
    .textarea:last-child{
      padding-bottom: 16px;
    }
    .textarea::after {
        border-bottom: none !important;
    }
    .textarea>>>  .van-field__value{
        margin-top: 16px;
    }
    .textarea>>> .van-field__label
    {
        display: inline-block;
    }
    .van-field>>> .van-field__value textarea{
        padding: 16px;
        background: #F2F4F5;
        border-radius: 6px;

        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #20253F;
        line-height: 16px;
        font-weight: 400;
    }
    .van-field>>> textarea::-webkit-input-placeholder,
    .van-field>>> textarea::-moz-placeholder,
    .van-field>>> textarea:-ms-input-placeholder,
    .van-field>>> textarea::-webkit-input-placeholder,
    .van-field>>> textarea::placeholder {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #9499B0;
      line-height: 16px;
      font-weight: 400;
    }

    .box2-btns
    {
        display: flex;
        flex-direction: row;
        margin: 0 20px 10px;
    }

    .box2-btn-add
    {
        flex:1;
        height: 44px;
        border: none;

        background: #FFFFFF;
        border-radius: 6px;

        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #0055FF;
        font-weight: 400;
    }

    .box2-btn-del
    {
        flex:1;
        height: 44px;
        border: none;

        background: #FFFFFF;
        border-radius: 6px;

        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #111E36;
        font-weight: 400;
    }

    .bottom-btns
    {
        background-color: #ffffff;
        padding: 16px;
        width: calc(100% - 32px);
        display: flex;
        flex-direction: row;
        position: fixed;
        bottom: 0px;
        left: 0px;
    }

    .bottom-btn
    {
        flex: 1;
        border: none;

        height: 44px;
        background-image: linear-gradient(270deg, #206CFE 0%, #4C88FF 100%);
        border-radius: 4px;

        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #FFFFFF;
        font-weight: 400;
    }

    .bottom-btn-default
    {
      flex: 1;
      border: none;

      height: 44px;
      background-color: #F5F7FA;
      border-radius: 4px;

      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #20253F;
      font-weight: 400;
    }

    .van-picker>>> .van-picker__confirm {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #3A5FFF;
    }
    .van-picker>>> .van-picker__cancel {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #20253F;
    }

    .van-picker>>> .van-picker-column__item{
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #CCCFD8;
    }

    .van-picker>>> .van-picker-column__item--selected{
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #3A5FFF;
    }

    .xieyi
    {
      font-family: PingFangSC-Regular;
      font-size: 10px;
      color: #666D7F;
      font-weight: 400;
      margin: 20px;
    }
    .xieyi>>> .van-checkbox{
      align-items: flex-start;
    }
    .xieyi>>> .van-checkbox__label{
      line-height: 1.5;
    }
    .dialog-preview
    {
        height: 98%;
        top: 50%;
    }

    .dialog-preview>>> .van-dialog__footer
    {
        position: relative;
        bottom: 0;
    }

    .popup{

    }
    .popup>>> .van-popup__close-icon--top-right {
      top: 10px;
    }
    .popup>>> .van-popup__close-icon {
      color: #111E36;
    }
    .popup-title{
      margin: 12px 20px;
      height: 18px;
      font-family: PingFangSC-Medium;
      font-size: 17px;
      color: #111E36;
      text-align: center;
      line-height: 18px;
      font-weight: 500;
    }
    .popup-input{
      box-sizing: border-box;
      margin: 16px 20px 4px;
      padding: 12px;
      height: 40px;
      background: rgba(247,249,250,0.50);
      border: 1px solid #E6EBF5;
      border-radius: 4px;
    }
    .popup-input>>> .van-cell{
      padding: 0;
      background-color: transparent;
    }
    .popup-btns
    {
      background-color: #ffffff;
      padding: 16px 20px;
      width: calc(100% - 32px);
      display: flex;
      flex-direction: row;
    }

    .pr{
      padding-bottom: 24px;
      border-bottom: none;
    }
    .pr::after
    {
      content: '说明：请如实填写，面试时需携带相关材料';
      font-size: 12px;
      transform:none;
      color: #3A5FFF;
    }


</style>
<style>
.van-dialog__message{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #20253F !important;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}
.van-dialog__cancel{
  height: 40px !important;
  background: #F5F7FA !important;
  border-radius: 4px;

  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #20253F;
  text-align: center;
  font-weight: 400;
}
.van-dialog__confirm
{
  height: 40px !important;
  background: none;
  background-image: linear-gradient(270deg, #206CFE 0%, #4C88FF 100%);
  border-radius: 4px;

  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}
.van-dialog__cancel+.van-dialog__confirm
{
  margin-left: 12px;
}
</style>
